import Axios from "axios";
import { SETTINGS } from "../../../properties/ApiProps";

export const TrainingRepository = {
  saveTrainingData: (vacId, data) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/${vacId}/trainings`,
      method: "POST",
      data: data,
    });
  },
  getTrainingData: (vacId) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/${vacId}/trainings`,
      method: "GET",
    });
  },
  getAllRoles: (gradingSchemaId, organizerId) => {
    return Axios({
      url: `${SETTINGS.API_URL}trainingRoles`,
      method: "GET",
      params: {
        gradingSchemaId: gradingSchemaId,
        organizerId: organizerId,
      },
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  getAllOrganizers: (gradingSchemaId) => {
    return Axios({
      url: `${SETTINGS.API_URL}trainingOrganizers`,
      method: "GET",
      params: {
        gradingSchemaId: gradingSchemaId,
      },
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  getAllHourRanges: (gradingSchemaId) => {
    return Axios({
      url: `${SETTINGS.API_URL}trainingHourRanges`,
      method: "GET",
      params: {
        gradingSchemaId: gradingSchemaId,
      },
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  uploadFile: (vacId, appDomain, file) => {
    const data = new FormData();
    data.append("file", file);

    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/${vacId}/${appDomain}/attachments`,
      method: "PUT",
      data: data,
    });
  },
  deleteFile: (attachmentId) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancyApplications/attachment/${attachmentId}`,
      method: "DELETE",
    });
  },

  updatePoints: (id, points) => {
    return Axios({
      url: `${SETTINGS.API_URL}training/${id}/points`,
      params: { points: points },
      method: "PUT",
    });
  },

  unlockPoints: (id) => {
    return Axios({
      url: `${SETTINGS.API_URL}training/${id}/unlockPoints`,
      method: "PUT",
    });
  },

  setComment: (id, comment) => {
    return Axios({
      url: `${SETTINGS.API_URL}training/${id}/comment`,
      params: { comment: comment },
      method: "PUT",
    });
  },
};
